import { useLayoutEffect, useState, useRef } from 'react';

const FALLBACK_MS = 1200;

export const useWidgetAnimation = (delayClass = '') => {
  const [animating, setAnimating] = useState(false);
  const timerRef = useRef(null);

  useLayoutEffect(() => {
    setAnimating(true);

    timerRef.current = setTimeout(() => {
      setAnimating(false);
    }, FALLBACK_MS);

    return () => clearTimeout(timerRef.current);
  }, []);

  return animating ? `widget-animate-enter ${delayClass}` : '';
};
